module.exports = __webpack_public_path__ + "img/m-sho_rounded.f2012bc6.svg";